import urlParse from '@collaborator/npm_modules/dist/helpers/url/urlParse';

class ScrollToBlock {
  static init() {
    this.processQuery();
    document.addEventListener('click', this.handlerClick);
  }

  static scrollToIfTopIsNotViewport(target: HTMLElement): void {
    if (window.pageYOffset > target.getBoundingClientRect().top) {
      ScrollToBlock.scrollTo(target);
    }
  }

  static scrollTo(target: HTMLElement): void {
    if (!target) {
      return;
    }
    target.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }

  public static processQuery() {
    const { query } = urlParse(window.location.search);
    if ('scrollTo' in query) {
      ScrollToBlock.scrollTo(document.getElementById(query.scrollTo));
    }
  }

  private static handlerClick(e) {
    const { target } = e;

    if (!target.classList.contains('scroll-to-element')) {
      return;
    }

    const destination = document.getElementById(urlParse(target.href).query.scrollTo);
    if (!destination) {
      return;
    }

    e.preventDefault();
    ScrollToBlock.scrollTo(destination);
  }
}

export default ScrollToBlock;
